import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6 2.75C6 2.05964 6.55964 1.5 7.25 1.5C7.94036 1.5 8.5 2.05964 8.5 2.75V4H16V2.75C16 2.05964 16.5596 1.5 17.25 1.5C17.9404 1.5 18.5 2.05964 18.5 2.75V4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4H6V2.75ZM4 14V12H11V14H4ZM4 16V18H11V16H4ZM13 18H20V16H13V18ZM20 14V12H13V14H20Z",
      fill: "currentColor"
    })
  ]))
}